import PrivateLeagueBasicUpdateRequestBody from "../../PrivateLeagues/Models/Request/Update/PrivateLeagueBasicUpdateRequestBody";

export default class ChallengeUpdateModel extends PrivateLeagueBasicUpdateRequestBody {
  public type: string = "ONE_VS_ONE";
}
